import { useQuery } from 'react-query';
import { ApplicationService } from '../../services/v1/ApplicationService';
import { Application } from '../../entities/v1/applicant_tracking/Application';

export const useApplication = (applicationId?: number, expand?: string[]) =>
  useQuery<Application>(['applications', applicationId], async () => {
    if (!applicationId) return null;

    return await ApplicationService.show(applicationId, expand);
  });
